import React from "react";
import { Form } from "react-bootstrap";
import { IoSearch } from "react-icons/io5";

const SearchForm = ({
  searchType,
  searchValue,
  handleSearchTypeChange,
  handleSearchValueChange,
  handleSearch,
}) => {
  const getSearchLabel = () => {
    switch (searchType) {
      case "lan":
        return "LAN";
      case "prospectId":
        return "Prospect ID";
      case "aadharNo":
        return "Aadhar Number";
      case "mobileNo":
        return "Mobile Number";
      case "memberName":
        return "Member Name";
      default:
        return "Value";
    }
  };

  const labelText = getSearchLabel();

  return (
    <div className="d-flex align-items-center gap-2 flex-nowrap">
      <div style={{ minWidth: "150px" }}>
        <Form.Select
          value={searchType}
          onChange={handleSearchTypeChange}
          className="search-form-select"
          style={{
            height: "34px",
            padding: "4px 28px 4px 10px",
            borderRadius: "8px",
            fontSize: "0.85rem",
            fontWeight: "600",
            border: "1.5px solid var(--slate-300)",
            backgroundColor: "var(--slate-50)",
          }}
        >
          <option value="lan">LAN</option>
          <option value="prospectId">Prospect ID</option>
          <option value="aadharNo">Aadhar Number</option>
          <option value="mobileNo">Mobile Number</option>
          <option value="memberName">Member Name</option>
        </Form.Select>
      </div>

      <div className="search-input-wrapper" style={{ minWidth: "240px" }}>
        <input
          type="text"
          value={searchValue}
          onChange={handleSearchValueChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearch(e);
            }
          }}
          placeholder={`Enter ${labelText}...`}
          className="search-input"
          style={{ height: "34px" }}
        />
        <span className="search-icon">
          <IoSearch />
        </span>
      </div>

      <button
        type="button"
        className="btn btn-addCredential m-0 px-3 text-nowrap"
        style={{ height: "34px", fontSize: "0.85rem", flexShrink: 0 }}
        onClick={handleSearch}
      >
        Search
      </button>
    </div>
  );
};

export default SearchForm;